import * as appConfig from "../config/config";

/** BAM DPA Appendix 2 floor, and the value shipped if nothing configures one. */
const DEFAULT_MIN_PASSWORD_LENGTH = 12;

// Driven by VITE_PASSWORD_MIN_LENGTH, which must match the backend's
// PASSWORD_MIN_LENGTH — see config/config.ts.
//
// Read defensively: Metro resolves this import to config.native.ts, which does
// not define passwordMinLength. Without the fallback native would get undefined,
// and `length < undefined` is false — silently disabling the length check.
export const MIN_PASSWORD_LENGTH =
  Number((appConfig as { passwordMinLength?: number }).passwordMinLength) ||
  DEFAULT_MIN_PASSWORD_LENGTH;

export function isPasswordValid(password: string): boolean {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return false;
  }
  const hasNumber = /[0-9]/.test(password);
  // Define common symbols using a character set in regex
  const hasSymbol =
    /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\;\'\:\"\,\<\.\>\/\?\|\\~`]/.test(
      password
    );
  return hasNumber || hasSymbol;
}

export function isPasswordOneNumberSymbolValid(password: string): boolean {
  const hasNumber = /[0-9]/.test(password);
  // Define common symbols using a character set in regex
  const hasSymbol =
    /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\;\'\:\"\,\<\.\>\/\?\|\\~`]/.test(
      password
    );
  return hasNumber || hasSymbol;
}
